import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Notification } from "@vds/core";
import {
  setIsPOYDFlow,
  removeAllPOYDDocuments,
  setIsPOYDFromGridwall
} from "pages/Mobility/ducks/MobilitySlice";
import POYDModal from "./POYDModal";

export default function POYDNotification() {
  const dispatch = useDispatch();
  const { t } = useTranslation(["app"]);
  const aem = t("poyd.notification", { returnObjects: true });
  const [showPoydModal, setShowPoydModal] = useState(false);
  const payOffCredit = useSelector((state) => state.MobilityPage?.poydBillAmount)

  const onReuploadClick = () => {
    // Logic for re-uploading the bill
    console.log("Re-upload bill clicked");
    setShowPoydModal(true);
  };

  const onClearDeviceClick = () => {
    // Logic for clearing the POYD device
    console.log("Clear POYD device clicked");
    dispatch(removeAllPOYDDocuments());
    dispatch(setIsPOYDFlow(false));
    dispatch(setIsPOYDFromGridwall(false));
  };

  return (
    <>
      <Notification
        kind={aem?.kind ?? "success"}
        title={aem?.title ?? "Thanks for submitting your bill!"}
        bodyText={t("poyd.notification.bodyText", { payOffCredit, returnObjects: true })}
        buttons={
          (Array.isArray(aem?.buttons) &&
            aem.buttons.map((button) => ({
              key: button.key,
              kind: button.kind,
              children: button.children,
              onClick:
                button.key === "reupload"
                  ? onReuploadClick
                  : onClearDeviceClick,
            }))) ||
          []
        }
      />
      <POYDModal opened={showPoydModal} onOpenedChange={setShowPoydModal} />
    </>
  );
}
